import Admin from "../Admin";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";
import CardAdminFeeScheduleList from "../../../Component/Card/Admin/FeeSchedule/CardAdminFeeScheduleList";

export default class FeeScheduleList extends Admin {
  /**
   * Render the content.
   */
  renderContent() {
    return <CardAdminFeeScheduleList />;
  }

  /**
   * Render the header.
   */
  renderHeader() {
    const handleClickCreate = () => {
      this.props.history.push({
        pathname: "/admin/feeSchedule",
      });
    };

    const buttons = [
      <MUIButton
        component="label"
        variant="contained"
        startIcon={<MUIAddIcon />}
        onClick={handleClickCreate}
      >
        Create New
      </MUIButton>,
    ];

    return <PageHeader title="Fee Schedules" buttons={buttons} />;
  }
}
